export const ROLES = Object.freeze({
  ADMIN: 'admin',
  CUSTOMER: 'customer',
});

export const isAdmin = (role) => role === ROLES.ADMIN;
export const isCustomer = (role) => role === ROLES.CUSTOMER;

export const canAccessRoute = (role, allowedRoles) => (
  !allowedRoles || allowedRoles.includes(role)
);
